import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Box } from '@material-ui/core';
import ExternalDataHistorySearchComponent from './ExternalDataHistorySearchComponent';
import ExternalDataHistoryListComponent from './ExternalDataHistoryListComponent';
import ExternalDataHistoryDownloadComponent from './ExternalDataHistoryDownloadComponent';
import { setInitMessage } from '../../actions/CommonAction';
import {
  setExTab,
  getImportStatus,
  importBusinesscard,
} from '../../actions/ExternalDataHistoryAction';
import { EXTERNALDATA_TAB, TR_COMMON_HISTORY_STATUS } from '../../../common/const';
import './ExternalDataHistoryComponent.css';
import ExternalDataSendHistorySearchComponent from './ExternalDataSendHistorySearchComponent';
import ExternalDataSendHistoryListComponent from './ExternalDataSendHistoryListComponent';

/**
 * 外部データ取込履歴画面全体
 */
class ExternalDataHistoryComponent extends Component {
  async componentDidMount() {
    // Google Analytics
    window.gtagPageview();
    const {
      userInfo,
      getImportStatusAct,
      startImportPollingAct,
    } = this.props;
    if (userInfo && userInfo.businesscard_contact === 1) {
      // ダウンロードステータス情報取得
      const ret = await getImportStatusAct();
      // ダウンロードステータスが処理中の場合、ポーリング処理を開始
      if (ret) {
        await startImportPollingAct();
      }
    }
  }

  componentWillUnmount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  /**
  * タブ切り替え
  */
  tabClick = (newTab) => {
    const { setExTabAct, setInitMessageAct } = this.props;
    setExTabAct(newTab);
    setInitMessageAct();
  };

  /**
  * 名刺取込
  */
  onClickImport = () => {
    // 一時保存領域条件クリア
    const {
      importBusinesscardAct,
    } = this.props;
    importBusinesscardAct();
  }

  render() {
    const {
      extab,
      importStatus,
      userInfo,
    } = this.props;
    let importStateMessage = null;

    // ダウンロードステータス表示判定
    if (importStatus) {
      // ダウンロードステータスに応じた文言を作成
      if (importStatus.status === TR_COMMON_HISTORY_STATUS.PROCESSING) {
        // 処理中
        importStateMessage = '※取込処理中';
      }
    }

    return (
      <div className="externaldata">
        <div className="externalDataHeadder">
          <div className="tabGroup">
            <Button
              className={[
                'tab',
                extab === EXTERNALDATA_TAB.TAB_INPORT ? 'selected' : null,
              ].join(' ')}
              onClick={() => {
                this.tabClick(EXTERNALDATA_TAB.TAB_INPORT);
              }}
              tabIndex="-1"
            >
              外部データ取込
            </Button>
            <Button
              className={[
                'tab',
                extab === EXTERNALDATA_TAB.TAB_EXPORT ? 'selected' : null,
              ].join(' ')}
              onClick={() => {
                this.tabClick(EXTERNALDATA_TAB.TAB_EXPORT);
              }}
              tabIndex="-1"
            >
              外部送信
            </Button>
          </div>
          { userInfo.businesscard_contact === 1 && extab === EXTERNALDATA_TAB.TAB_INPORT
                && (
                  importStatus ? (
                    <>
                      <Box>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.onClickImport}
                          disabled={importStatus.status === TR_COMMON_HISTORY_STATUS.PROCESSING}
                          className="meishiBotton"
                        >
                          名刺取込
                        </Button>

                        {importStatus.status === TR_COMMON_HISTORY_STATUS.PROCESSING
                        && importStateMessage
                        && (
                        <p className="importmMessage">{importStateMessage}</p>
                        )}
                      </Box>
                    </>
                  ) : (
                    <>
                      <div>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.onClickImport}
                          className="meishiBotton"
                        >
                          名刺取込
                        </Button>
                      </div>
                    </>
                  )
                )}
        </div>
        {extab === EXTERNALDATA_TAB.TAB_INPORT
          ? (
            <div className="container">
              <div className="container1">
                <ExternalDataHistorySearchComponent
                  tabClick={() => this.tabClick(EXTERNALDATA_TAB.TAB_INPORT)}
                  tab={extab}
                  togglePopup={this.togglePopup}
                />
              </div>
              <div className="container2">
                <ExternalDataHistoryListComponent />
              </div>
            </div>
          ) : ''}
        {extab === EXTERNALDATA_TAB.TAB_EXPORT
          ? (
            <div className="container">
              <div className="container1">
                <ExternalDataSendHistorySearchComponent
                  tabClick={() => this.tabClick(EXTERNALDATA_TAB.TAB_EXPORT)}
                  tab={extab}
                  togglePopup={this.togglePopup}
                />
              </div>
              <div className="container2">
                <ExternalDataSendHistoryListComponent />
              </div>
            </div>
          ) : ''}
        <ExternalDataHistoryDownloadComponent />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    extab: state.externaldata.extab,
    importStatus: state.externaldata.importStatus,
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    setExTabAct: (extab) => dispatch(setExTab(extab)),
    setInitMessageAct: () => dispatch(setInitMessage()),
    getImportStatusAct: () => dispatch(getImportStatus()),
    importBusinesscardAct: () => dispatch(importBusinesscard()),
  }),
)(ExternalDataHistoryComponent);
